import { render, staticRenderFns } from "./AppAccountsNew.vue?vue&type=template&id=373d1024&lang=pug&"
import script from "./AppAccountsNew.vue?vue&type=script&lang=ts&"
export * from "./AppAccountsNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports